import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer, useLocalizerFormat } from './hooks/useLocalizer';

const MaxUserNotesLength = 1000;

interface AIContextualInstructionFieldProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    localizer?: IStringLocalizer;
}

export const AIContextualInstructionField: React.FC<AIContextualInstructionFieldProps> = ({
    value,
    onChange,
    disabled = false,
    localizer
}) => {
    const localize = useLocalizer(localizer);
    const localizeFormat = useLocalizerFormat(localizer);
    const charactersLeft = MaxUserNotesLength - value.length;

    return (
        <div className="ai-contextual-instruction-field">
            <label htmlFor="aiContextualInstructions" className="ai-contextual-instruction-label">
                {localize("Add any details that might help our agent interpret your uploaded files.")}
            </label>
            <div className="ai-contextual-instruction-textarea-container">
                <textarea
                    id="aiContextualInstructions"
                    className="form-control ai-contextual-instruction-textarea"
                    rows={3}
                    maxLength={MaxUserNotesLength}
                    value={value}
                    onChange={(event) => onChange(event.target.value.slice(0, MaxUserNotesLength))}
                    disabled={disabled}
                    placeholder={localize('e.g. "These files are relevant for all materials in the survey." OR "File names ComplianceLetter are related to materials 1, 2 and 3. But file RoHSStatement is just related to Material 4."')}
                />
            </div>
            <span className="ai-contextual-instruction-character-count">
                {localizeFormat("{0} characters left", charactersLeft.toString())}
            </span>
        </div>
    );
};

export default AIContextualInstructionField;
